import { z } from 'zod';
import { PRIORITY_ID } from 'Constants/priority';

const baseSchema = z.object({
  evaluationDate: z.date(),
  evaluationDateTouched: z.boolean(),
  file: z.instanceof(File).nullable(),
  selectedUserCourseIds: z.array(z.string()).min(1, 'Selecciona al menos un empleado'),
});

/**
 * Construye el schema según la prioridad del curso. Para Técnica el archivo es obligatorio.
 * Definida como factory para invalidar resolver cache cuando cambia la prioridad.
 */
export const buildBulkApproveSchema = (priorityId: string) =>
  baseSchema.superRefine((data, ctx) => {
    if (priorityId === PRIORITY_ID.tecnica && !data.file) {
      ctx.addIssue({
        code: 'custom',
        path: ['file'],
        message: 'El archivo de evidencia es obligatorio para cursos técnicos',
      });
    }
  });

export type BulkApproveFormValues = z.infer<typeof baseSchema>;
